import React, { useState, useEffect, useContext } from "react";
import "./autorizacija.css";
import AuthorizationEmployeeItem from "../authorizationEmployeeItem";
import NewUser from "../newUser";
import ImportKorisnika from "../importKorisnika";
import { baseRequest } from "../../../axiosconfig";
import Loading from "../../loading";
import DropDown from "../../elements/dropDown";
import { downloadFile } from "../../../utils/download";
import { UserContext } from "../../../userContext";
import { ROLES } from "../../../constants/roles";
import DeleteMapaPopup from "../../deleteMapaPopup";

function Autorizacija(props) {
  const { user } = useContext(UserContext);
  // Isto pravilo kao na serveru (requireRole(1) za kreiranje korisnika)
  const canManageUsers = user && user.role_id === ROLES.SUPER_ADMIN;
  const employeesListTitles = [
    { id: 1, title: "Organizaciona jedinica*", width: "19%" },
    { id: 2, title: "Zaposleni*", width: "19%" },

    { id: 3, title: "Rola*", width: "18%" },
    { id: 4, title: "Imejl adresa", width: "17%" },
    { id: 5, title: "Lozinka", width: "18%" },
  ];

  const sortOptions = [
    { id: 1, name: "Svi" },
    { id: 2, name: "A -Z" },
    { id: 3, name: "Z - A" },
  ];

  const [usersList, setUsersList] = useState();
  const [newUser, setNewUser] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [users, setUsers] = useState(null);

  const [loading, setLoading] = useState(false);
  const [designations, setDesignations] = useState();
  const [organization_units, setOrganizationUnits] = useState();
  const [sortOption, setSortOption] = useState({ id: 1, name: "Svi" });
  const [roles, setRoles] = useState();
  const [userValidationErrors, setUserValidationErrors] = useState();
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleteError, setDeleteError] = useState(null);
  // uvoz naloga iz Excela: prikaz popup-a i osvežavanje liste posle uvoza
  const [showImport, setShowImport] = useState(false);
  const [usersReload, setUsersReload] = useState(0);

  function formatDesignations(list) {
    return list.map((item) => {
      return {
        id: item.id,
        del: item.del,
        level: item.level,
        parent_id: item.parent_id,
        name: item.designation
          ? `${item.first_name} ${item.last_name} - ${item.designation.name}`
          : item.designation_name
          ? `${item.first_name} ${item.last_name} - ${item.designation_name}`
          : `${item.first_name} ${item.last_name}`,
        designation_name: item.designation
          ? item.designation.name
          : item.designation_name,
      };
    });
  }

  const filterActualUnits = (list) => {
    return list.filter((unit) => {
      return !unit.del && unit.has_designations === true;
    });
  };

  useEffect(() => {
    // Rola bez prava administracije ne učitava korisnike (server ih odbija sa 403)
    if (!canManageUsers) return;
    setLoading(true);
    const urls = [
      "/employee/id/0/level/0",
      "/organization_unit/0",
      "/roles",
      "/users",
    ];
    Promise.all(
      urls.map((url) => baseRequest.get(url))
    )
      .then((res) => {
        setLoading(false);

        const responseObj = {};
        res.forEach((item) => {
          if (item.data.data) {
            if (item.data.data.length > 0 && item.data.data[0].first_name) {
              responseObj["designations"] = formatDesignations(
                item.data.data
              ).filter((des) => !des.del);
            } else {
              responseObj["organization_units"] = filterActualUnits(
                item.data.data
              );
            }
          } else if (item.data.roles) {
            responseObj["roles"] = item.data.roles;
          } else if (item.data.users) {
            responseObj["users"] = item.data.users.filter(
              (user) => user.employee_id
            );
          }
        });

        setRoles(responseObj["roles"] || []);
        setOrganizationUnits(responseObj["organization_units"] || []);
        setDesignations(responseObj["designations"] || []);
        const safeDesignations = responseObj["designations"] || [];
        const safeUnits = responseObj["organization_units"] || [];
        const safeUsers = responseObj["users"] || [];
        setUsersList(
          safeUsers
            .map((user) => {
              const des = safeDesignations.find(
                (worker) => worker.id === user.employee_id
              );
              if (!des) return null;
              const unit = safeUnits.find(
                (un) => un.id === des.parent_id && un.level === des.level
              );
              if (!unit) return null;
              return {
                ...user,
                designation: des,
                unit: unit,
                filteredDesignations: safeDesignations.filter(
                  (el) => el.parent_id === unit.id && el.level === unit.level
                ),
              };
            })
            .filter(Boolean)
        );
      })
      .catch(() => {
        setLoading(false);
      });
  }, [canManageUsers, usersReload]);

  const handleAddNewUser = () => {
    setNewUser({ adding: true });
  };

  const handleSelectOrganizationUnit = ({ value }) => {
    if (userValidationErrors) {
      const { organization_unit_id, ...rest } = userValidationErrors;
      setUserValidationErrors(rest);
    }
    setNewUser((newUser) => {
      return { ...newUser, organization_unit: value, designation: null };
    });
  };

  const handleSelectDesignation = ({ value }) => {
    if (userValidationErrors) {
      const { employee_id, ...rest } = userValidationErrors;
      setUserValidationErrors(rest);
    }
    setNewUser((newUser) => {
      return { ...newUser, designation: value };
    });
  };

  const handleSelectRole = ({ value }) => {
    if (userValidationErrors) {
      const { role_id, ...rest } = userValidationErrors;
      setUserValidationErrors(rest);
    }
    setNewUser((newUser) => {
      return { ...newUser, role: value };
    });
  };

  const handleChangeRoleInput = (e, key) => {
    if (userValidationErrors) {
      const { [key]: something, ...rest } = userValidationErrors;
      setUserValidationErrors(rest);
    }
    setNewUser((newUser) => {
      return { ...newUser, [key]: e.target.value.trimStart() };
    });
  };

  //saving new user

  const handleSaveNewUser = (user) => {
    const payLoad = {
      level: user?.organization_unit?.level,
      organization_unit_id: user?.organization_unit?.id,
      employee_id: user?.designation?.id,
      email: user?.email,
      password: user?.password,
      role_id: user?.role?.id,
    };

    if (validateUser(payLoad)) {
      return;
    }

    setLoading(true);
    baseRequest
      .post("/user", payLoad)
      .then((res) => {
        setLoading(false);
        const des = designations.find(
          (worker) => worker.id === res.data.data.employee_id
        );

        const unit = organization_units.find(
          (un) => un.id === des.parent_id && un.level === des.level
        );

        const filteredDesignations = designations.filter(
          (el) => el.parent_id === unit.id && el.level === unit.level
        );
        setUsersList((list) => {
          return [
            ...list,
            { ...res.data.data, unit, designation: des, filteredDesignations },
          ];
        });
        setNewUser(null);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data?.message || error.response?.data?.errors) {
          setUserValidationErrors((errors) => {
            return { ...errors, ...error.response?.data?.errors };
          });
        }
      });
  };

  //delete new user

  const handleDeleteNewUser = () => {
    setNewUser(null);
    setUserValidationErrors(null);
  };

  const filterDesignations = (list, id, level) => {
    const filteredList = list.filter(
      (des) => (des.parent_id === id) && (des.level === level)
    );

    const filteredListWithDisabled = filteredList.map((worker) => {
      const match = usersList.find((us) => us.employee_id === worker.id);
      if (match) {
        return { ...worker, isDisabled: true };
      }
      return worker;
    });

    if (usersList) {
      return filteredListWithDisabled;
    } else {
      return filteredList;
    }
  };

  const handleSetEditUser = (id) => {
    setUsersList((list) => {
      const newUsers = list.map((user) => {
        if (user.id === id) {
          return { ...user, editing: true };
        }
        return user;
      });
      return newUsers;
    });
  };

  const handleSelectUserUnit = (id) => {
    return function (unit) {
      setUsersList((list) => {
        const newUsers = list.map((user) => {
          if (user.id === id) {
            return {
              ...user,
              unit: unit.value,
              designation: null,
              filteredDesignations: designations.filter(
                (des) =>
                  des.parent_id === unit.value.id &&
                  des.level === unit.value.level
              ),
            };
          }
          return user;
        });
        return newUsers;
      });
    };
  };

  const handleSelectUserDesignation = (id) => {
    return function (designation) {
      setUsersList((list) => {
        const newUsers = list.map((user) => {
          if (user.id === id) {
            return {
              ...user,

              designation: designation.value,
            };
          }
          return user;
        });
        return newUsers;
      });
    };
  };

  const handleChangeUserRole = (id) => {
    return function (value) {
      setUsersList((list) => {
        const newUsers = list.map((user) => {
          if (user.id === id) {
            return {
              ...user,

              role: value.value,
            };
          }
          return user;
        });
        return newUsers;
      });
    };
  };

  const handleChangeUser = (e, id, field = "email") => {
    if (userValidationErrors) {
      const { [field]: _, ...rest } = userValidationErrors;
      setUserValidationErrors(rest);
    }

    setUsersList((list) => {
      const newUsers = list.map((user) => {
        if (user.id === id) {
          return {
            ...user,
            [field]: e.target.value.trimStart(),
          };
        }
        return user;
      });
      return newUsers;
    });
  };

  const handleUpdateUser = (payload) => {
    const load = {
      id: payload.id,
      employee_id: payload.designation
        ? payload.designation.id
        : payload.employee_id,
      email: payload.email,
      password: payload.password ? payload.password : "",
      role_id: payload.role ? payload.role.id : payload.role_id,
      organization_unit_id: payload.organization_unit_id,
      level: payload.level,
    };
    if (validateUser(load, true)) {
      return;
    }
    setLoading(true);
    baseRequest
      .put("/user", load)
      .then((res) => {
        setLoading(false);
        setUsersList((list) => {
          const newUsers = list.map((user) => {
            if (user.id === res.data.data.id) {
              const { editing, ...rest } = user;
              return { ...rest, ...res.data.data };
            }
            return user;
          });
          return newUsers;
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data?.message || error.response?.data?.errors) {
          setUserValidationErrors((errors) => {
            return { ...errors, ...error.response?.data?.errors };
          });
        }
      });
  };

  // Kanta samo otvara potvrdu; brisanje ide tek na „Da“ (isti obrazac kao N-02)
  // Sopstveni nalog se ne deaktivira (isto pravilo važi i na serveru)
  const handleDeleteUser = (item) => {
    if (user && item.id === user.id) {
      setDeleteError("Ne možete deaktivirati sopstveni korisnički nalog.");
      return;
    }
    setDeleteError(null);
    setUserToDelete(item);
  };

  const handleConfirmDeleteUser = () => {
    const user = userToDelete;
    setUserToDelete(null);
    setLoading(true);
    baseRequest
      .delete(`/user/${user.id}`)
      .then((res) => {
        setLoading(false);
        setUsersList((list) => {
          const newUsers = list.filter((listUser) => {
            return listUser.id !== user.id;
          });
          return newUsers;
        });
        setUserValidationErrors(null);
      })
      .catch((err) => {
        setLoading(false);
        setDeleteError(
          err?.response?.data?.message ||
            "Nalog nije deaktiviran. Pokušajte ponovo."
        );
      });
  };

  const validateUser = (user, updating = false) => {
    const { level, ...rest } = user;
    const userErrors = updating
      ? Object.keys(rest).filter((key) => {
          if (key !== "password") {
            return !rest[key];
          }
        })
      : Object.keys(rest).filter((key) => {
          return !rest[key];
        });

    const errors = {};

    if (userErrors.length > 0) {
      userErrors.forEach((er) => {
        errors[er] = "Obavezno polje";
      });
      setUserValidationErrors(errors);
      return true;
    } else {
      return false;
    }
  };

  // Strana je samo za administratora — isti obrazac kao Evidencija aktivnosti
  if (!canManageUsers) {
    return (
      <div>
        <div
          className="processes-header"
          style={{ justifyContent: "space-between", height: "51px" }}
        >
          <div className="org-unit-title">Autorizacija</div>
        </div>
        <p style={{ padding: "20px", color: "var(--mainColor)" }}>
          Nemate pravo pristupa autorizaciji (samo administrator).
        </p>
      </div>
    );
  }

  return (
    <div>
      <div
        className="processes-header"
        style={{ justifyContent: "space-between", height: "51px" }}
      >
        <div className="org-unit-title">Autorizacija</div>
        <div style={{ marginRight: "10px", display: "flex", gap: "10px" }}>
          <button
            className="add-btn-large"
            title="Otvaranje korisničkih naloga iz .xlsx fajla sa privremenim lozinkama"
            style={{ fontSize: "12px", padding: "0 10px", whiteSpace: "nowrap", width: "auto" }}
            onClick={() => setShowImport(true)}
          >
            UVEZI KORISNIKE IZ EXCELA
          </button>
          <button
            className="add-btn-large"
            title="Izvoz svih podataka preduzeća u mašinski čitljivom formatu (JSON)"
            style={{ fontSize: "12px", padding: "0 10px", whiteSpace: "nowrap", width: "auto" }}
            onClick={() => downloadFile("/export/full", "efuk-izvoz.json")}
          >
            IZVEZI SVE PODATKE (JSON)
          </button>
        </div>
        {/* <div className="sort-options-dropdown" style={{ width: "auto" }}>
          <div style={{ flex: "1" }}>Sortiraj po:</div>
          <DropDown
            dropDownStyle={{ width: "auto" }}
            height={"49px"}
            list={sortOptions}
            selectedValue={sortOption.name}
            containerValue={{ alignItems: "baseline", fontWeight: "bold" }}
            paddingLeft={"5px"}
            menu={{ width: "100px" }}
          />
        </div> */}

        {/* <div className="sort-options-dropdown" style={{ width: "200px" }}>
          <div
            className="sort-options-dropdown-selected"
            onClick={() => {
              setShowDropdown((state) => !state);
            }}
          >
            <span style={{ marginRight: "7px", paddingLeft: "10px" }}>
              Filtriraj po:
            </span>

            <img
              alt=""
              src="/images/sidebararrow.png"
              className="sidebar-navigation-item-arrow"
            ></img>
          </div>

          {showDropdown && (
            <ul
              className="sort-options-dropdown-options"
              style={{ left: "0", zIndex: "100", flex: 1 }}
            >
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Svi
              </li>

              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Rukovodilac
              </li>
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Zaposleni
              </li>
            </ul>
          )}
        </div> */}
      </div>
      <div className="table-scroll">
        <ul className="authorization-titles-list">
          {employeesListTitles.map((item) => {
            return (
              <li
                key={item.id}
                className=" authorization-titles-list-item"
                style={{ width: item.width }}
              >
                {item.title}
              </li>
            );
          })}
        </ul>
        {deleteError && (
          <div className="errormessage" style={{ margin: "10px 0" }}>
            {deleteError}
          </div>
        )}
        {usersList && usersList.length > 0 && (
          <ul className="autorization-employees-list">
            {usersList.map((user) => {
              return (
                <AuthorizationEmployeeItem
                  key={user.id}
                  user={user}
                  designations={designations}
                  organization_units={organization_units}
                  roles={roles}
                  handleSetEditUser={handleSetEditUser}
                  handleSelectUserUnit={handleSelectUserUnit}
                  handleSelectUserDesignation={handleSelectUserDesignation}
                  handleChangeUserRole={handleChangeUserRole}
                  handleChangeUser={handleChangeUser}
                  handleUpdateUser={handleUpdateUser}
                  handleDeleteUser={handleDeleteUser}
                  userValidationErrors={userValidationErrors}
                />
              );
            })}
          </ul>
        )}
        <div className="new-user-block">
          {newUser && (
            <NewUser
              organization_units={organization_units}
              designations={filterDesignations(
                designations,
                newUser?.organization_unit?.id,
                newUser?.organization_unit?.level
              )}
              roles={roles}
              handleSelectOrganizationUnit={handleSelectOrganizationUnit}
              handleSelectDesignation={handleSelectDesignation}
              handleSelectRole={handleSelectRole}
              handleChangeRoleInput={handleChangeRoleInput}
              handleSaveNewUser={handleSaveNewUser}
              handleDeleteNewUser={handleDeleteNewUser}
              newUser={newUser}
              userValidationErrors={userValidationErrors}
            />
          )}
          {canManageUsers && (
            <button
              onClick={handleAddNewUser}
              className={
                designations
                  ? "add-new-user-btn"
                  : "add-new-user-btn add-new-user-btn-disabled"
              }
              disabled={!designations}
            >
              <span style={{ marginRight: "3px" }}>+</span>
              <span>Dodajte korisnika</span>
            </button>
          )}
        </div>
      </div>
      {userToDelete && (
        <div className="loading">
          <DeleteMapaPopup
            setItemToDelete={setUserToDelete}
            loading={loading}
            handleItemDelete={handleConfirmDeleteUser}
          />
        </div>
      )}
      {showImport && (
        <ImportKorisnika
          onClose={() => setShowImport(false)}
          onImported={() => setUsersReload((n) => n + 1)}
        />
      )}
      <Loading isLoading={loading} />
    </div>
  );
}

export default Autorizacija;
